import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ClientOrManager } from '@/api/profile';

@Component({
})
export default class PersonalInfo extends Vue {
    @Prop({default: null}) profile!: ClientOrManager
}